import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteGuaranteeCategory($id: ID!) {
        deleteGuaranteeCategory(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
